let lockCount = 0;
let previousOverflow = '';
/**
 * Hides body overflow while at least one options sheet is open.
 * A later sheet must not restore the previous value on unmount, or an earlier sheet would leave the page scrollable.
 */
export const lockBodyScroll = () => {
    if (typeof document === 'undefined') {
        return () => undefined;
    }
    if (lockCount === 0) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
    lockCount += 1;
    let released = false;
    return () => {
        if (released) {
            return;
        }
        released = true;
        lockCount -= 1;
        if (lockCount === 0) {
            document.body.style.overflow = previousOverflow;
        }
    };
};
/** Test-only. Production sheets release the lock from the backdrop effect cleanup. */
export const resetBodyScrollLockForTests = () => {
    lockCount = 0;
    previousOverflow = '';
    if (typeof document !== 'undefined') {
        document.body.style.overflow = '';
    }
};
//# sourceMappingURL=lock_body_scroll.js.map